import { useEffect } from 'react';
import { cancelAllPendingEffects, cleanupFloatingScores } from '../utils/gameJuice';

/**
 * Hook to clean up all game effects when component unmounts.
 * Use this on game pages (RoomPage, PracticeMatchPage, etc.) to ensure
 * all animations and effects are properly cleaned up when navigating away.
 */
export const useGameEffectsCleanup = () => {
  useEffect(() => {
    return () => {
      // Clean up all pending timers and DOM elements
      cancelAllPendingEffects();
      cleanupFloatingScores();
    };
  }, []);
};
